






































































































import {Component, Vue} from "vue-property-decorator";
import TextBox from "@/components/TextBox.vue";
import Quote from "@/components/Quote.vue";
import PathBox from "@/components/PathBox.vue";
import ImageText from "@/components/ImageText.vue";
import HeroBox from "@/components/HeroBox.vue";
import Player from "@/components/Player.vue";
import PlayerHead from "@/components/PlayerHead.vue";
import VideoContent from "@/components/VideoContent.vue";
import VideoBox from "@/components/VideoBox.vue";
import VideoSync from "@/components/VideoSync.vue";
import AnchorNav from "@/components/AnchorNav.vue";
import ImageGrid from "@/components/ImageGrid.vue";
import HeadingDivider from "@/components/HeadingDivider.vue";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {ThemePathPageConfig} from "@/interfaces/theme-path-page.interface";
import {MainPageConfig} from "@/interfaces/main-page.interface";
import ContentPage from "@/components/ContentPage.vue";
import LogoBox from "@/components/LogoBox.vue";
import Button from "@/components/Button.vue";

@Component({
  components: {
    HeadingDivider,
    ImageGrid,
    AnchorNav,
    VideoSync,
    VideoBox,
    VideoContent,
    PlayerHead,
    Player,
    HeroBox,
    ImageText,
    Quote,
    TextBox,
    PathBox,
    ContentPage,
    LogoBox,
    Button,
  }
})
export default class ThemePath extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  isLoading = true;
  pathArr = [];
  mediaQuery: any = null;
  isMobile: boolean = false;

  blockTypes = MainPageConfig.PageBlockTypes;
  filmViewModes = ThemePathPageConfig.FilmViewModes;

  pageContent: ThemePathPageConfig.IThemePathPageConfig;

  async created() {
    this.pageContent = await this.$store.dispatch("contentPage/getPageContent", {page: RouterStore.ROUTE_NAME.PATH_PAGE, id: this.$route.params.id});
    this.isLoading = false;
    setTimeout( this.initDraw );

    setTimeout( () => {
      bus.$emit(EventEmitter.Events.DATA_LOADED);
    })
  }

  mounted() {
    let videoPlayer = document.querySelectorAll('.player__content');
    let initialized = 0;
    this.mediaQuery = window.matchMedia("(min-width: 993px)");

    this.checkMedia(this.mediaQuery);
    this.mediaQuery.addListener(this.checkMedia);

    if (videoPlayer.length) {
      // Check if all players are loaded
      bus.$on(EventEmitter.Events.PLAYER_READY, () => {
        setTimeout(() => {
          initialized++;

          if (initialized === videoPlayer.length) {
            this.initDraw();
            window.addEventListener('resize', this.initDraw);
          }
        }, 200);
      });
    } else {
      this.initDraw();
    }

    // @todo replace it with page load checker
    setInterval( this.initDraw, 200 );
  }

  checkMedia(e) {
    e.matches ? this.isMobile = false : this.isMobile = true;
  }

  initDraw() {
    let pathSections = document.querySelectorAll('.theme-path__section');
    let prevPathBlock = null;
    let isPrevQuote = false;
    this.pathArr = [];

    for (let i = 0; pathSections.length > i; i++) {
      let currentSection = pathSections[i];
      let currentPathBlock = null;
      let isFirstSection = false;
      let isCurrentQuote = false;

      if (currentSection.classList.contains('theme-path__section--video')) {
        currentPathBlock = currentSection.querySelector('.player__content');
      } else if (currentSection.classList.contains('theme-path__section--text')) {
        currentPathBlock = currentSection.querySelector('.text-box');
      } else if (currentSection.classList.contains('theme-path__section--video-sync')) {
        currentPathBlock = currentSection.querySelector('.video-sync');
      } else if (currentSection.classList.contains('theme-path__section--image-grid')) {
        currentPathBlock = currentSection.querySelector('.image-grid');
      } else if (currentSection.classList.contains('theme-path__section--quote')) {
        currentPathBlock = currentSection.querySelector('.quote');
        isCurrentQuote = true;
      } else if (currentSection.classList.contains('theme-path__section--image-text')) {
        currentPathBlock = currentSection.querySelector('.image-text');
      }

      // To draw path need to have at least 2 blocks
      if (prevPathBlock === null) {
        prevPathBlock = currentPathBlock;
        continue;
      }

      // If drawable section is first
      if (i === 1) {
        isFirstSection = true;
      }

      this.drawPaths(prevPathBlock, currentPathBlock, isFirstSection, isPrevQuote, isCurrentQuote);
      prevPathBlock = currentPathBlock;
      isPrevQuote = isCurrentQuote;

      // If section is last and it's image-text
      if (i === (pathSections.length - 1) && currentSection.classList.contains('theme-path__section--image-text')) {
        currentPathBlock = currentSection.querySelector('.image-text__text');
        this.drawPaths(prevPathBlock, currentPathBlock, isFirstSection, isPrevQuote, isCurrentQuote);
      }
    }
  }

  drawPaths(prev, current, isFirstSection, isPrevQuote, isCurrentQuote) {
    let first, second;
    if (!prev || !current) return;

    if (isFirstSection) {
      first = {
        x: prev.getBoundingClientRect().left + (prev.getBoundingClientRect().width / 2),
        y: window.pageYOffset + prev.getBoundingClientRect().top + prev.getBoundingClientRect().height - 10,
      };
    } else if (isPrevQuote) {
      first = {
        x: prev.getBoundingClientRect().left + (this.isMobile ? (prev.getBoundingClientRect().width / 2) : 0),
        y: window.pageYOffset + prev.getBoundingClientRect().top + (this.isMobile ? (prev.getBoundingClientRect().height / 2) : prev.getBoundingClientRect().height),
      };
    } else {
      first = {
        x: prev.getBoundingClientRect().left + (prev.getBoundingClientRect().width / 2),
        y: window.pageYOffset + prev.getBoundingClientRect().top + (prev.getBoundingClientRect().height / 2),
      };
    }

    if (isCurrentQuote) {
      second = {
        x: current.getBoundingClientRect().left + (this.isMobile ? (current.getBoundingClientRect().width / 2) : 0),
        y: window.pageYOffset + current.getBoundingClientRect().top + (this.isMobile ? (current.getBoundingClientRect().height / 2) : 0),
      };
    } else {
      second = {
        x: current.getBoundingClientRect().left + (current.getBoundingClientRect().width / 2),
        y: window.pageYOffset + current.getBoundingClientRect().top + (current.getBoundingClientRect().height / 2),
      };
    }

    let pathStr = "M" +
      (first.x       ) + "," + (first.y) + " " +
      "C" +
      (first.x       ) + "," + (first.y + ((second.y - first.y) / 2)) + " " +
      (second.x      ) + "," + (second.y - ((second.y - first.y) / 2)) + " " +
      (second.x      ) + "," + (second.y);

    this.pathArr.push(pathStr);
  }

  destroy() {
    bus.$off(EventEmitter.Events.PLAYER_READY);
    window.removeEventListener('resize', this.initDraw);
  }
}
